<template>
    <div>
        <v-dialog v-model="main_dialog.display" persistent :retain-focus="false">
            <v-card>
                <v-toolbar dense color="primary" dark>
                    <v-row align="center" dark>
                        <v-col cols="5" align="left">
                            <v-toolbar-title>Gestione campi default</v-toolbar-title>
                        </v-col>
                        <v-col cols="2">
                            <v-btn small light @click="save">
                                <v-icon color="success">mdi-floppy</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="5" align="right">
                            <v-btn small light @click="close">
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-toolbar>
                <v-container v-if="fields!=null">
                    <v-tabs v-model="main_dialog.tabs" centered>
                        <v-tab v-for="(context,i) in main_dialog.contexts" :key="i">{{context.text}}</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="main_dialog.tabs">
                        <v-tab-item v-for="(context,i) in main_dialog.contexts" :key="i">
                            <v-data-table :headers="main_dialog.headers" :items="fields[context.field]" disable-pagination hide-default-footer class="mt-5" >
                                <template v-slot:top>
                                    <v-toolbar dense color="primary" rounded>
                                        <v-row justify="center">
                                            <v-col cols="1">
                                                <v-btn small light @click="addConfigField(context.field)">
                                                    <v-icon color="success">mdi-plus</v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-toolbar>
                                </template>
                                <!-- Nome -->
                                <template v-slot:[`item.nome`]="{ item }">
                                    <v-text-field label="Nome" v-model="item.nome" />
                                </template>
                                <!-- Campo -->
                                <template v-slot:[`item.campo`]="{ item }">
                                    <v-text-field label="Campo" v-model="item.campo" />
                                </template>
                                <!-- Tipo Input -->
                                <template v-slot:[`item.tipo`]="{ item }">
                                    <v-select label="Tipo dato" v-model="item.tipo" item-value="id_tipo_input" item-text="nome" :items="input_types"/>
                                </template>
                                <!-- Valore default -->
                                <template v-slot:[`item.valore_default`]="{ item }">
                                    <DynamicInput v-model="item.valore_default" :type="getInputType(item.tipo)" :items="getValues(item)" label="Valore default" item_text="testo" item_value="valore"/>
                                </template>
                                <!-- Valori -->
                                <template v-slot:[`item._values`]="{ item }">
                                    <v-btn small :disabled="item.validita!=1||getInputType(item.tipo)!='enum'" @click="openValues(item)">
                                        <v-icon color="primary">mdi-format-list-checkbox</v-icon>
                                    </v-btn>
                                </template>
                                <!-- Elimina -->
                                <template v-slot:[`item._delete`]="{ item }">
                                    <v-btn small @click="item.validita=item.validita==1?0:1">
                                        <v-icon :color="item.validita==1?'error':'success'">{{item.validita==1?'mdi-delete':'mdi-restore'}}</v-icon>
                                    </v-btn>
                                </template>
                            </v-data-table>
                        </v-tab-item>
                    </v-tabs-items>
                </v-container>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="values_dialog.display" :retain-focus="false">
            <v-card v-if="values_dialog.selected!=null">
                <v-toolbar dense color="primary" dark>
                    <v-row align="center" dark>
                        <v-col cols="5" align="left">
                            <v-toolbar-title>{{ values_dialog.selected.nome }}: Enumerazione</v-toolbar-title>
                        </v-col>
                        <v-col cols="1">
                            <v-btn small light @click="saveValues">
                                <v-icon color="success">mdi-floppy</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="1">
                             <v-btn small light @click="addValue">
                                <v-icon color="success">mdi-plus</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="5" align="right">
                            <v-btn small light @click="closeValues">
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-toolbar>
                <v-container>
                    <v-data-table :headers="values_dialog.headers" :items="values_dialog.cloned" disable-pagination hide-default-footer class="mt-5">
                        <!-- Testo -->
                        <template v-slot:[`item.testo`]="{ item }">
                            <v-text-field label="Testo" v-model="item.testo"/>
                        </template>
                        <!-- Valore -->
                        <template v-slot:[`item.valore`]="{ item }">
                            <v-text-field label="Valore" v-model="item.valore" type="number"/>
                        </template>
                        <!-- Elimina -->
                        <template v-slot:[`item._delete`]="{ item }">
                            <v-btn small @click="item.validita=item.validita==1?0:1">
                                <v-icon :color="item.validita==1?'error':'success'">{{item.validita==1?'mdi-delete':'mdi-restore'}}</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import DynamicInput from '../../.common/DynamicInput.vue';
export default {
    name:'GestioneCampiDefault',
    props : {
        input_types : Array
    },
    components : {
        DynamicInput
    },
    data(){
        return{
            fields:null,
            main_dialog : {                
                contexts : [
                    { field:'interface', text:'Interfacce' },
                    { field:'alarm', text:'Allarmi' },
                    { field:'upload', text:'Template di Upload' },
                    { field:'part_program', text:'Part Program' }
                ],
                display : false,
                headers : [
                    { text:'Nome', value:'nome' },
                    { text:'Campo', value:'campo' },
                    { text:'Tipo dato', value:'tipo' },
                    { text:'Valore default', value:'valore_default' },
                    { text:'Valori', value:'_values' },
                    { text:'Elimina/Ripristina', value:'_delete' }
                ],
                tabs:0
            },
            NETWORK : null,
            values_dialog : {
                cloned:null,
                display : false,
                headers : [
                    { text:'Testo', value:'testo' },
                    { text:'Valore', value:'valore' },
                    { text:'Elimina/Ripristina', value:'_delete' }
                ],
                selected : null
            }
        }
    },
    mounted(){
        this.NETWORK = this.$store.state.Network;
    },
    methods : {
        addConfigField(context){
            this.fields[context].push({
                id_campo_configurazione:-1,
                riferimento:null,
                tipo:null,
                nome:null,
                campo:null,
                valore_default:null,
                contesto:context,
                valori:new Array(),
                validita:1
            });
        },
        addValue(){
            this.values_dialog.cloned.push({
                id_valore:-1,
                riferimento:this.values_dialog.selected.id_campo_configurazione,
                valore:null,
                testo:null,
                validita:1
            });
        },
        close(){
            this.main_dialog.display = false;
            this.fields = null;
        },
        closeValues(){
            this.values_dialog.selected = null;
            this.values_dialog.cloned = null;
            this.values_dialog.display = false;
        },
        getInputType(id){
            for(let i=0; i<this.input_types.length;i++){
                if(this.input_types[i].id_tipo_input==id){ return this.input_types[i].valore; }
            }
            return null;
        },
        getValues(item){
            const result = new Array();
            for(let i=0; i<item.valori.length; i++){
                if(item.valori[i].validita==1){ result.push(item.valori[i]); }
            }
            return result;
        },
        open(){
            const that = this;
            this.fields = null;
            const request = {
                controller: 'quickconnext',
                endpoint : 'connext',
                response: { parse: false },
                    body: {
                        action: 'getdefaultschemafields',
                        token: localStorage.user_token,
                },
                method: 'POST',
                on: {
                    load: function (response) {
                        const fields = JSON.parse(response).campi;
                        const result = new Object();
                        for(let i=0; i<that.main_dialog.contexts.length; i++){
                            const context = that.main_dialog.contexts[i];
                            result[context.field] = new Array();
                        }
                        for(let i=0; i<fields.length; i++){
                            const field = fields[i];
                            if(result[field.contesto]!=null){
                                result[field.contesto].push(field);
                            }
                        }
                        that.fields = result;
                        that.main_dialog.display = true;
                    },
                },
            };
            this.NETWORK.AjaxRequest(request);            
        },
        openValues(item){
            this.values_dialog.selected = item;
            this.values_dialog.cloned = JSON.parse(JSON.stringify(item.valori));
            this.values_dialog.display = true;
        },
        save(){
            const fields = JSON.parse(JSON.stringify(this.fields));
            const result_fields = new Array();
            const result_values = new Array();            
            let uid=0;

            for(let i=0; i<this.main_dialog.contexts.length; i++){
                const context = this.main_dialog.contexts[i].field;
                for(let j=0; j < fields[context].length; j++){
                    const field = fields[context][j];
                    if(field.validita==0 && field.id_campo_configurazione==-1){ continue; }
                    field.tmp_uid = ++uid;
                    result_fields.push(field);

                    for(let k=0; k<field.valori.length; k++){
                        const value = field.valori[k];
                        if(value.validita==0 && value.id_valore==-1){ continue; }
                        value.tmp_rif_uid = field.tmp_uid;
                        result_values.push(value);
                    }
                    delete field.valori;
                }
            }

            const that = this;
            const request = {
                controller: 'quickconnext',
                endpoint : 'connext',
                response: { parse: false },
                    body: {
                        action: 'setdefaultschemafields',
                        token: localStorage.user_token,
                        campi:result_fields,
                        valori:result_values
                },
                method: 'PUT',
                on: {
                    load: function () {
                        that.close();
                    },
                },
            };
            this.NETWORK.AjaxRequest(request);
        },
        saveValues(){
            this.values_dialog.selected.valori = this.values_dialog.cloned;
            this.closeValues();
        },
    }
}
</script>